import { css } from '@emotion/css';

export const strengthLabel = css`
  margin-left: auto;
`;
